var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"title":"New Retailer","back":_vm.backRoute}},[_c('retailer-edit',{on:{"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }